/**
 * @typedef {Object} Map
 * @property {string} type - unique identifier
 * @property {string} value - column value
 */

/**
 * @typedef {Object} Mapping
 * @property {Object<string, Map>} columnMap - columns mapped by key.
 * @property {string} id - unique identifier
 * @property {string} name - mapping name
 * @property {string} vatNumber - vat number
 * @property {string} filingType - filing type
 * @property {number} headerStart - header row start
 * @property {number} rowStart - row start
 */

/**
 * Select mapping edit model
 * @param conversionToolMappingEdit - conversion tool embedded state slice
 * @returns {Mapping|{}}
 */
export const mappingEdit = ({ conversionTool: { conversionToolMappingEdit = {} } = {} } = {}) =>
  conversionToolMappingEdit.model.mapping || {};
